import React from 'react';
import {PlayCircleRounded} from '@mui/icons-material';
import BlockIcon from './BlockIcon';
import ReviewItemCard from './ReviewItemCard';

const VideoCard = ({id, title, selected, onToggle, meta, durationPill}) => (
    <ReviewItemCard
        id={id}
        text={title}
        checked={selected}
        onToggle={onToggle}
        icon={<BlockIcon outlined icon={<PlayCircleRounded />} />}
        meta={durationPill ? `${meta} · ${durationPill}` : meta}
    />
);

export default VideoCard;
